import type { AuthorizedUser } from './_internal';

export function hasStrongAuth<User>(mapUser: (user: User) => AuthorizedUser): (user: User) => boolean;
export function hasStrongAuth<User extends AuthorizedUser = AuthorizedUser>(): (user: User) => boolean;
export function hasStrongAuth<User>(mapUser?: (user: User) => AuthorizedUser) {
  return (user: User) => {
    const u = mapUser ? mapUser(user) : (user as unknown as AuthorizedUser);

    const isImpersonating = u.impersonatorEmail && u.impersonatorUserToken;
    if (isImpersonating && u.isLoggedIn) {
      return true;
    }

    if (u.isUserBlocked) return false;

    if (!u.isLoggedIn) return false;
    if (!u.email && !u.userToken) return false;
    if (u.isInitialMultiFactorAuthenticationRequired) return false;
    if (!u.hasStrongAuthentication) return false;

    return true;
  };
}
